export const IconSearch: {
  name: 'icon_search-c785559136d1'
} = {
  name: 'icon_search-c785559136d1'
}
